module.exports = __webpack_public_path__ + "img/folder.71822883.svg";